var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroissant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9095 18.125L25.1094 9.625C25.2452 9.48887 25.3491 9.32432 25.4136 9.14322C25.4781 8.96212 25.5016 8.76899 25.4825 8.5777C25.4633 8.38641 25.402 8.20173 25.3029 8.03699C25.2039 7.87225 25.0695 7.73155 24.9095 7.625C18.9095 4.125 12.9094 4.125 6.80945 7.625C6.64943 7.73155 6.51505 7.87225 6.41597 8.03699C6.31688 8.20173 6.25556 8.38641 6.23643 8.5777C6.2173 8.76899 6.24084 8.96212 6.30534 9.14322C6.36984 9.32432 6.4737 9.48887 6.60945 9.625L15.9095 18.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9094 18.1252H3.70941C3.43365 18.1267 3.16165 18.0611 2.91689 17.9341C2.67212 17.8071 2.46194 17.6224 2.30446 17.396C2.14698 17.1696 2.04694 16.9084 2.01296 16.6347C1.97898 16.361 2.01207 16.0832 2.10941 15.8252C2.88652 13.3161 4.55939 11.1805 6.8094 9.8252",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9092 18.1252H28.0092C28.2849 18.1267 28.5569 18.0611 28.8017 17.9341C29.0465 17.8071 29.2566 17.6224 29.4141 17.396C29.5716 17.1696 29.6717 16.9084 29.7056 16.6347C29.7396 16.361 29.7065 16.0832 29.6092 15.8252C28.8321 13.3161 27.1592 11.1805 24.9092 9.8252",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1092 18.125C2.7092 21.025 3.7092 23.925 5.6092 26.825L14.9092 18.125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6092 18.125C29.0092 21.025 28.0092 23.925 26.1092 26.825L16.9092 18.125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroissant);
export default __webpack_public_path__ + "static/media/croissant.3427394137f11d675744632866c8b092.svg";
export { ForwardRef as ReactComponent };